module.exports = __webpack_public_path__ + "static/media/table_back_active.6325aed5.png";